import Filter from './Filter';

export default class YearFilter extends Filter {
  get name () {
    return 'year';
  }

  get label () {
    return 'Jaar';
  }

  get UI () {
    return 'year';
  }

  get pro () {
    return false;
  }

  constructor () {
    super();
    this.options = undefined;
  }

  updateFromSearchProfile (searchprofile, filter) {
    filter.active = !!searchprofile.municipalBudgetYear;
    filter.options = searchprofile.municipalBudgetYear;
  }

  toSearchProfile (options) {
    if (options) {
      return {
        municipalBudgetYear: options
      };
    }
  }
}
